import { basePipe } from "./pipe";
const compose = basePipe(true);
var compose_default = compose;
export {
  compose_default as default
};
//# sourceMappingURL=compose.js.map
